import React, { useState, useEffect } from "react";
import './consignmentListDetails.css'
import { Row, Col } from 'react-bootstrap';
import { PROD } from "../../../common/constants";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { GET_CONSIGNMENT_DETAILS_BY_NUMBER } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

import Moment from 'moment';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';
import { Fab, Typography, Button, Grid, Stack, Divider, CardContent, Card, Container } from '@mui/material';
import moment from 'moment';
import apiClient from "../../../axios";

function ConsignmentListDetails() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [consignmentNumberDetail, setConsignmentNumberDetail] = useState();
    const consignmentData = useLocation().state?.selectedRow;
    const [firstPartyDetails, setFirstPartyDetails] = useState();
    const [invoiceDetails, setInvoiceDetails] = useState();

    const cols1 = [
        { field: 'scheduleLineNumber', headerName: t('pit.scheduleLineNo'), width: 130 },
        { field: 'sourceStakeholderPo', headerName: t('pit.growerPo'), width: 130 },
        { field: 'sourceStakeholderUrn', headerName: t('pit.firstPartyUrn'), width: 150 },
        { field: 'sourceLocationName', headerName: t('pit.firstPartyLocName'), width: 150 },
        { field: 'sourceLocationAddress', headerName: t('pit.firstPartyLocAddress'), width: 160 },
        { field: 'consignmentStatus', headerName: t('pit.status'), width: 180 },
    ]

    const cols2 = [
        { field: 'invoiceNo', headerName: t('pit.invoiceNo'), width: 130 },
        {
            field: 'invoiceDate', headerName: t('pit.invoiceDate'), width: 130,
            valueFormatter: params => params?.value != null ? Moment(params?.value).format("DD/MM/YYYY") : " "
        },

        { field: 'invoiceType', headerName: t('pit.invoiceType'), width: 130 },
        { field: 'invoiceAmount', headerName: t('pit.invoiceAmount'), width: 130 },
        { field: 'stakeholderUrn', headerName: t('pit.urn'), width: 130 }


    ]

    // const rows = [
    //     { id: 1, scheduleLineNo: "009", growerPO: "PO-0091", firstPartyUrn: "URN-KAKGR00652", firstPartyLocName: "Grower Loc N", firstPartyLocAdd: "Grower", status: "created", invoiceNo: "INV-0089", invoiceDate: "12/03/2023", invoiceAmount: "1200"},
    //     { id: 2, scheduleLineNo: "009", growerPO: "PO-0091", firstPartyUrn: "URN-KAKGR00652", firstPartyLocName: "Grower Loc N", firstPartyLocAdd: "Grower", status: "created", invoiceNo: "INV-0089", invoiceDate: "12/03/2023", invoiceAmount: "1200"},
    // ]

    useEffect(() => {
        if (consignmentData.consignmentNumber) {
            getConsignmentDetailsByNumber();
        }
    }, []);

    const getConsignmentDetailsByNumber = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
                {
                    consignmentNumber: consignmentData?.consignmentNumber
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    }
                },
                null
            ).then((response) => {
                setConsignmentNumberDetail(response.data);
                setFirstPartyDetails(response.data.consignmentSourceDetails);
                setInvoiceDetails(response.data.invoices);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

 function LabelAndValue({ label, value }) {
 return (
<Box display="flex" mb={1}>
<Typography variant="subtitle2" sx={{ minWidth: "200px" }}>
       {label}:
</Typography>
<Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
       {value}
</Typography>
</Box>
 );
}

const tripStart = consignmentNumberDetail?.consignmentMilestones?.find(
 m => m.eventType === "TripStarted"
);
const tripEnd = consignmentNumberDetail?.consignmentMilestones?.find(
 m => m.eventType === "TripEnded"
);


    return (
        <Container maxWidth="xxl">
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT50</p>}
            <Typography variant="h4" sx={{ mb: 2 }}>
                <Fab onClick={() => { navigate('../consignmentList', { state: { tabValue: state?.tabValue } }) }} size="small" aria-label="back" title='Back'>
                    <KeyboardArrowLeftRounded />
                </Fab> {t('pit.consignmentDetails')}
            </Typography>
            <Card>
                <CardContent>

  {/* ---------------------- Section 1: Consignment + Pickup ---------------------- */}
<Card sx={{ p: 2, mb: 3 }}>
<Typography variant="h6" sx={{ mb: 1 }}>Consignment & Pickup Details</Typography>
<Grid container spacing={1}>

      {/* Use <Grid item xs={12} sm={6}> for each field */}
<Grid item xs={12} sm={6}><LabelAndValue label="Consignment No" value={consignmentNumberDetail?.consignmentNo} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup URN" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.sourceStakeholderUrn} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Transporter URN" value={consignmentNumberDetail?.consignmentSourceUrn} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup Location PO" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.sourceStakeholderPo} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Transporter PO" value={consignmentNumberDetail?.servicePoNumber} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="PickUp Name" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.sourceName} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Transporter Name" value={consignmentNumberDetail?.consignmentOwnerName} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup Location Address" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.sourceLocationAddress} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Transporter Contact" value={consignmentNumberDetail?.consignmentOwnerContactNo} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Type of Loading" value={consignmentNumberDetail?.typeOfLoading} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Type of Inventory" value={consignmentNumberDetail?.materialType} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Schedule Date" value={moment(consignmentNumberDetail?.consignmentScheduleDate).format("DD/MM/YYYY")} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Consignment Status" value={consignmentNumberDetail?.consignmentStatus} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Schedule Line No" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.scheduleLineNumber} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Vehicle Reg No" value={consignmentNumberDetail?.vehicleRegNo} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Vehicle Capacity (MT)" value={consignmentNumberDetail?.consignmentWeight} /></Grid>





</Grid>
</Card>

  {/* ---------------------- Section 2: Delivery ---------------------- */}
<Card sx={{ p: 2, mb: 3 }}>
<Typography variant="h6" sx={{ mb: 1 }}>Delivery Details</Typography>
<Grid container spacing={1}>
<Grid item xs={12} sm={6}><LabelAndValue label="Delivery Location URN" value={consignmentNumberDetail?.consignmentDestinationStakeholderUrn} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Driver Name" value={consignmentNumberDetail?.driverName} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Delivery Location Name" value={consignmentNumberDetail?.consignmentDestinationContactName} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Driver License No" value={consignmentNumberDetail?.driverLicenseNo} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Delivery Location Address" value={consignmentNumberDetail?.consignmentDestinationLocationAddress} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Driver Contact" value={consignmentNumberDetail?.driverContact} /></Grid>


</Grid>
</Card>

  {/* ---------------------- Section 3: Other Details ---------------------- */}
<Card sx={{ p: 2, mb: 3 }}>
<Typography variant="h6" sx={{ mb: 1 }}>Weighment</Typography>
<Grid container spacing={1}>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup Tare Weight (MT)" value={consignmentNumberDetail?.pickupTareWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Destination Gross Weight (MT)" value={consignmentNumberDetail?.destinationGrossWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup Gross Weight (MT)" value={consignmentNumberDetail?.pickupGrossWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Destination Tare Weight (MT)" value={consignmentNumberDetail?.destinationTareWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Pickup Net Weight (MT)" value={consignmentNumberDetail?.pickupNetWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Destination Net Weight (MT)" value={consignmentNumberDetail?.destinationNetWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Average Moisture at Pickup" value={consignmentNumberDetail?.totalMoisture} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Moisture (Destination)" value={consignmentNumberDetail?.destinationTotalMoisture} /></Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label="Odometer Start Reading" value={tripStart?.odometerReading} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label="Odometer End Reading" value={tripEnd?.odometerReading} />
</Grid>
{/* <Grid item xs={12} sm={6}><LabelAndValue label="Bundle Selection Weight" value={consignmentNumberDetail?.consignmentSourceDetails?.[0]?.totalWeight} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Deviation Moisture %" value={consignmentNumberDetail?.deviationMositurePercent} /></Grid>
<Grid item xs={12} sm={6}><LabelAndValue label="Deviation Weight %" value={consignmentNumberDetail?.deviationWeightPercent} /></Grid> */}
</Grid>
</Card>
</CardContent>

{/* ---------------------- Table: First Party Details ---------------------- */}
{/* <Typography sx={{ mt: 4, mb: 1 }} variant="subtitle1">{t('pit.firstPartyDetails')}</Typography> */}

{/* {firstPartyDetails && (
<DataGrid

    autoHeight

    rows={firstPartyDetails}

    columns={cols1}

    hideFooterPagination

  />

)} */}

{/* ---------------------- Table: Second Party Details ---------------------- */}
{/* <Typography sx={{ mt: 4, mb: 1 }} variant="subtitle1">{t('pit.secondPartyDetails')}</Typography>
<Grid container spacing={2}>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.grossWeightInMT')} value={consignmentNumberDetail?.destinationGrossWeight} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.tareWeightInMT')} value={consignmentNumberDetail?.destinationTareWeight} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.netWeightInMT')} value={consignmentNumberDetail?.destinationNetWeight} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.averageMoisture')} value={consignmentNumberDetail?.destinationTotalMoisture} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.DeviationWeightPer')} value={consignmentNumberDetail?.deviationWeightPercent} />
</Grid>
<Grid item xs={12} sm={6}>
<LabelAndValue label={t('pit.deviationMoisturePer')} value={consignmentNumberDetail?.deviationMositurePercent} />
</Grid>
</Grid> */}
 
 
            </Card>
        </Container>
    )
}
export default ConsignmentListDetails;